import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrivateNavbarComponent } from '../private-navbar/private-navbar.component';
import { FooterComponent } from '../footer/footer.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-private-layout',
  standalone: true,
  imports: [RouterModule, PrivateNavbarComponent, FooterComponent, TranslateModule],
  templateUrl: './private-layout.component.html',
  styleUrl: './private-layout.component.css'
})
export class PrivateLayoutComponent {

}
